import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Button } from 'components';
import Affiliate from './affiliate/affiliate';
import Seller from './seller/seller';
import { ClinicIcon, DoctorIcon } from 'assets/icons';
import { ProfileService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const TABS = {
	AFFILIATE: 1,
	SELLER: 2,
}

class Commissions extends React.Component<Props> {

	state = {
		tab: TABS.AFFILIATE,
		document_types: [],
		phonecodes: [],
		specialities: [],
		states: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Comisiones',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await ProfileService.getDocumentTypes({
			withoutLoading: true
		});
		this.setState({
			document_types: res.document_types,
			phonecodes: res.phonecodes,
			specialities: res.specialities,
			states: res.states
		});
	}

	setTab = (tab: number) => {
		this.setState({ tab });
	}

	render() {
		return (
			<div id="admin-register">
				{
					this.state.tab === TABS.AFFILIATE && (
						<Affiliate
							history={ this.props.history }
							tabs={<Tabs setTab={this.setTab} tab={this.state.tab} />}
						/>
					)
				}

				{
					this.state.tab === TABS.SELLER && (
						<Seller
							history={ this.props.history }
							tabs={<Tabs setTab={this.setTab} tab={this.state.tab} />}
						/>
					)
				}
			</div>
		)
	}
}

interface TabsProps {
	setTab: (tab: number) => void;
	tab: number;
}

const Tabs = ({ setTab, tab }: TabsProps) => (
	<div className="row-tabs-2">
		<Button onClick={() => setTab(TABS.AFFILIATE)} className={tab === TABS.AFFILIATE ? 'active' : ''}>
			<div>
				<img src={DoctorIcon} alt="icon" />
			</div>
			<p>Afiliado</p>
		</Button>
		<Button onClick={() => setTab(TABS.SELLER)} className={tab === TABS.SELLER ? 'active' : ''}>
			<div>
				<img src={ClinicIcon} alt="icon" />
			</div>
			<p>Vendedor/Agente de afiliación</p>
		</Button>
	</div>
)

export default connect()(Commissions);